import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from './hooks/redux';
import { fetchSession } from './store/slices/authSlice';
import Home from './pages/Home';
import BuildTree from './pages/BuildTree';
import Structures from './pages/Structures';
import Projects from './pages/Projects';
import Settings from './pages/Settings';
import Assets from './pages/Assets';
import SalesOrders from './pages/SalesOrders';
import Blueprints from './pages/Blueprints';
import IndustryJobs from './pages/IndustryJobs';
import BuyOrders from './pages/BuyOrders';
import SupplyChain from './pages/SupplyChain';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';

function App() {
  const dispatch = useAppDispatch();
  const { sessionToken, initialized } = useAppSelector((state) => state.auth);

  useEffect(() => {
    const token = localStorage.getItem('sessionToken');
    if (token && !initialized) {
      dispatch(fetchSession(token));
    }
  }, [dispatch, initialized]);

  if (!initialized && localStorage.getItem('sessionToken')) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Routes>
        <Route path="/login" element={sessionToken ? <Navigate to="/" /> : <Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/" element={sessionToken ? <Home /> : <Navigate to="/login" />} />
        <Route path="/build-tree" element={sessionToken ? <BuildTree /> : <Navigate to="/login" />} />
        <Route path="/structures" element={sessionToken ? <Structures /> : <Navigate to="/login" />} />
        <Route path="/projects" element={sessionToken ? <Projects /> : <Navigate to="/login" />} />
        <Route path="/assets" element={sessionToken ? <Assets /> : <Navigate to="/login" />} />
        <Route path="/industry-jobs" element={sessionToken ? <IndustryJobs /> : <Navigate to="/login" />} />
        <Route path="/buy-orders" element={sessionToken ? <BuyOrders /> : <Navigate to="/login" />} />
        <Route path="/sales-orders" element={sessionToken ? <SalesOrders /> : <Navigate to="/login" />} />
        <Route path="/sales-orders/:orderNumber" element={sessionToken ? <SalesOrders /> : <Navigate to="/login" />} />
        <Route path="/blueprints" element={sessionToken ? <Blueprints /> : <Navigate to="/login" />} />
        <Route path="/supply-chain" element={sessionToken ? <SupplyChain /> : <Navigate to="/login" />} />
        <Route path="/settings" element={sessionToken ? <Settings /> : <Navigate to="/login" />} />
      </Routes>
    </div>
  );
}

export default App;
